import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {StoreService} from 'src/app/services/store.service';

@Component({
  selector: 'app-store-itens',
  templateUrl: './store-itens.component.html',
  styleUrls: [ './store-itens.component.scss' ]
})
export class StoreItensComponent implements OnInit {

  public products: any[]=[];

  constructor (
    private _activeRoute: ActivatedRoute,
    private _storeService: StoreService,

  ) { }

  ngOnInit () {
    this._activeRoute.params.subscribe(data => {
      const param = Number(data[ 'param' ]);
      this.loadItens(param)
    })
  }

  async loadItens (param: number) {
    // 0 = faz parte do menu congresso
    // 1 = faz parte do menu cursos
    // 2 = faz parte do menu prova
    // 3 = faz parte do menu anuidade
    this.products = await this._storeService.loadProduts(param);
    console.log(JSON.stringify(this.products))

  }
}
